import { render, staticRenderFns } from "./ListaProdutosDisponiveisInsumos.vue?vue&type=template&id=062c29a2&"
import script from "./ListaProdutosDisponiveisInsumos.vue?vue&type=script&lang=js&"
export * from "./ListaProdutosDisponiveisInsumos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports